import { Typography, Box } from "@mui/material";
import moment from "moment";
import { BsDot } from "react-icons/bs";
import * as colors from "@mui/material/colors";

export function getColorShades(color) {
  const muiColor = colors[color];
  return {
    lightest: muiColor[50],
    lighter: muiColor[100],
    light: muiColor[300],
    main: muiColor[500],
    dark: muiColor[900],
  };
}

export function formatDate(date) {
  const momentDate = moment(date);
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      {isToday(momentDate)
        ? "Today"
        : isYesterday(momentDate)
        ? "Yesterday"
        : momentDate.format("DD MMM YYYY")}{" "}
      <BsDot />
      {momentDate.format("h:mm A")}
    </span>
  );
}

export function formatDateSplitLine(date) {
  const momentDate = moment(date);
  return (
    <Box>
      <Typography variant="body2">
        {isToday(momentDate)
          ? "Today"
          : isYesterday(momentDate)
          ? "Yesterday"
          : momentDate.format("DD MMM YYYY")}
      </Typography>
      <Typography variant="caption" color={"textSecondary"}>
        {momentDate.format("h:mm A")}
      </Typography>
    </Box>
  );
}

export function groupByDate(data) {
  const groups = {};
  data.forEach((item) => {
    const date = moment(item["updated_at"]);
    const dayFormat = date.format("DD MMM YYYY");

    if (isToday(date)) {
      if (groups["Today"]) {
        groups["Today"].push(item);
      } else {
        groups["Today"] = [item];
      }
    } else if (isYesterday(date)) {
      if (groups["Yesterday"]) {
        groups["Yesterday"].push(item);
      } else {
        groups["Yesterday"] = [item];
      }
    } else {
      if (groups[dayFormat]) {
        groups[dayFormat].push(item);
      } else {
        groups[dayFormat] = [item];
      }
    }
  });

  const groupsArray = Object.keys(groups).map((date) => {
    return {
      date,
      items: groups[date],
    };
  });
  return groupsArray;
}

export function getSessionItemDate(date) {
  const momentDate = moment(date);
  const now = moment();
  const differenceInHours = now.diff(momentDate, "hours");
  const differenceInMinutes = now.diff(momentDate, "minutes");
  const differenceInSeconds = now.diff(momentDate, "seconds");

  // if the day of the date is same as current date's day, then whatsapp like date format
  if (isToday(momentDate)) {
    if (differenceInSeconds < 60) {
      return "just now";
    } else if (differenceInMinutes < 60) {
      const isDifferenceEqualOneMinute = differenceInMinutes === 1;
      return isDifferenceEqualOneMinute
        ? `a minute ago`
        : `${differenceInMinutes} minutes ago`;
    } else if (differenceInHours < 24) {
      return `${differenceInHours} hour${differenceInHours > 1 ? "s" : ""} ago`;
    }
  }
  return momentDate.format("h:mm A");
}

function isYesterday(date) {
  const yesterday = moment().subtract(1, "day");
  return date.isSame(yesterday, "day");
}

function isToday(date) {
  const today = moment();
  return date.isSame(today, "day");
}

export const AI_GENERATED_ILLUSTRATION =
  "https://res.cloudinary.com/ravenapp/image/upload/v1705045125/ai_copilot/AI_Generated_Illustration_pf5ozj.png";

export const defaultLottieOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const toTitleCase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getGreeting = () => {
  const currentHour = moment().hour();

  if (currentHour >= 5 && currentHour < 12) {
    return "Good Morning";
  } else if (currentHour >= 12 && currentHour < 17) {
    return "Good Afternoon";
  }
  return "Good Evening";
};

export const getUserNameShortform = (name) => {
  if (!name) {
    return "U";
  }
  // const arr = name.split(" ");
  // if (arr.length > 1) {
  //   return `${arr[0][0]}${arr[1][0]}`.toUpperCase();
  // }
  return name[0];
};

export const models = ["gpt-4o", "claude-3.5-sonnet"];

// can be a list of cloudinary image urls
const newSessionBgImages = [
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153139/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_11_v2lnlf.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153138/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_7_thyi4z.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153138/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_15_sku0m2.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153137/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_14_izfno9.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153137/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_10_o9altx.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153136/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_4_kga2mw.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153137/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_12_rn9gac.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153137/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_13_ctcbjp.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153136/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_5_xnsaft.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153136/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_8_lz082t.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153135/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_6_myzk5a.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153134/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_9_d6mkw7.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153135/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_3_zcmqam.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153133/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_1_fp6azv.jpg",
  "https://res.cloudinary.com/ravenapp/image/upload/fl_progressive/v1724153134/ai_copilot/new-session-bg-images/Raven-AI-Cover-Illustration_2_h6kqrt.jpg",
];

export function getRandomBgImage() {
  if (newSessionBgImages.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * newSessionBgImages.length);

  return newSessionBgImages[randomIndex];
}

export const fileTypeObj = {
  "image/png": "png",
  "image/jpeg": "jpeg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
  "text/plain": "txt",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "text/csv": "csv",
  "application/pdf": "pdf",
};

export const operatorSymbol = {
  equals: "=",
  greater_than: ">",
  less_than: "<",
  like: "%",
  in: "in",
  between: "between",
};

String.prototype.format = function () {
  return [...arguments].reduce((p, c) => p.replace(/%s/, c), this);
};
